import React from 'react';
import { LOGO_URL } from '../lib/config';

const LadderHeader = ({
  isSignedIn,
  viewMode,
  onChangeViewMode,
  onToggleChatSidebar,
  onAuthClick,
  onLogoutClick,
  onOpenSettings,
}) => (
  <div className="flex-shrink-0 bg-[#1a1d24] border-b border-[#374151] px-4 md:px-6 py-3 md:py-4 flex flex-col md:flex-row items-center justify-between relative gap-3 md:gap-0">
    <div className="w-full md:w-auto flex items-center justify-between md:justify-start">
      <img
        src={LOGO_URL}
        alt="Ladder"
        className="w-10 h-10 md:w-12 md:h-12 rounded-lg object-cover cursor-pointer hover:opacity-80 transition-opacity shadow-lg"
        onClick={isSignedIn ? onToggleChatSidebar : onAuthClick}
        title={isSignedIn ? 'Toggle Chat Sidebar' : 'Sign in with Google'}
      />
      <div className="md:hidden flex items-center gap-2">
        <button
          onClick={isSignedIn ? onOpenSettings : onAuthClick}
          className="px-3 py-1.5 bg-[#374151] text-[#e4e6eb] rounded-lg hover:bg-[#4b5563] transition-colors text-xs font-medium"
          title={isSignedIn ? 'Settings' : 'Sign in with Google'}
        >
          ⚙️
        </button>
        {isSignedIn && (
          <button
            onClick={onLogoutClick}
            className="px-3 py-1.5 bg-[#374151] text-[#e4e6eb] rounded-lg hover:bg-[#4b5563] transition-colors text-xs font-medium"
          >
            Logout
          </button>
        )}
      </div>
    </div>

    <div className="w-full md:w-auto md:absolute md:left-1/2 md:-translate-x-1/2 bg-[rgba(255,255,255,0.05)] p-1 rounded-full flex items-center gap-2 shadow-lg justify-center">
      <button
        onClick={() => onChangeViewMode('cards')}
        className={`px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-medium transition-all ${
          viewMode === 'cards' ? 'bg-[#374151] text-[#e4e6eb]' : 'text-[rgba(255,255,255,0.7)] hover:text-[#e4e6eb]'
        }`}
      >
        Search
      </button>
      <button
        onClick={() => onChangeViewMode('table')}
        className={`px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-medium transition-all ${
          viewMode === 'table' ? 'bg-[#374151] text-[#e4e6eb]' : 'text-[rgba(255,255,255,0.7)] hover:text-[#e4e6eb]'
        }`}
      >
        My Alumni
      </button>
    </div>

    <div className="hidden md:flex items-center gap-3">
      <button
        onClick={isSignedIn ? onOpenSettings : onAuthClick}
        className="px-4 py-2 bg-[#374151] text-[#e4e6eb] rounded-lg hover:bg-[#4b5563] transition-colors text-sm font-medium"
        title={isSignedIn ? 'Settings' : 'Sign in with Google'}
      >
        ⚙️ Settings
      </button>
      {isSignedIn && (
        <button
          onClick={onLogoutClick}
          className="px-4 py-2 bg-[#374151] text-[#e4e6eb] rounded-lg hover:bg-[#4b5563] transition-colors text-sm font-medium"
        >
          Logout
        </button>
      )}
    </div>
  </div>
);

export { LadderHeader };
